import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { useTheme } from 'modules/styles/index.js'
import { AppFAQItems } from 'pages/Faq/components/Items/index.js'

const messages = defineMessages({
  title: {
    id: 'AppFAQ.title',
    defaultMessage: 'Frequently Asked Questions'
  }
})

export function AppFAQ () {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Block
      bgc='backgroundContent'
      style={{
        textAlign: 'center'
      }}
    >
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View
          mr
          mx
          style={{
            margin: `0 ${STYLES_MARGIN.BIG} ${STYLES_MARGIN.BIG}`
          }}
        >
          <TextTitleCompressedHeavy>
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCompressedHeavy>
        </View>

        <AppFAQItems />
      </View>
    </Block>
  )
}
